import { FC, useState } from 'react'

import { RenderIf } from 'shared/helpers/renderIf'

import galleryPlaceholder from 'shared/images/background-placeholder.png'

import QuestionIcon from '@mui/icons-material/QuestionMark'
import PlusIcon from '@mui/icons-material/FileUpload'
import RemoveIcon from '@mui/icons-material/DeleteOutline'

import { FileInputContainer, Handlers, HiddenInput, Placeholder, Title } from './styled'
import { ConfirmationModal } from 'entities/ConfirmationModal'

export const FileInput: FC<FileInputProps> = ({
  id,
  onChange,
  onDelete,
  background,
  width = 320,
  height = 180,
  title = '',
  onHelpClick
}) => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)

  const fileToDataUrl = (file: any): any =>
    new Promise(resolve => {
      const reader = new FileReader()
      reader.onload = (event: any) => {
        resolve(event.target.result)
      }
      reader.readAsDataURL(file)
    })

  const handleChange = async (e: any) => {
    const file = e.target.files?.[0]
    if (!file) return
    const data = await fileToDataUrl(file)
    onChange(data)
    e.target.value = ''
  }

  const handleOnHelpClick = (event: any) => {
    if (onHelpClick) {
      event.stopPropagation()
      event.preventDefault()
      onHelpClick()
    }
  }

  return (
    <>
      <FileInputContainer width={width} height={height} $background={background} title={title}>
        <RenderIf condition={!background}>
          <Placeholder>
            <img src={galleryPlaceholder} alt='gallery placeholder' />
          </Placeholder>
        </RenderIf>

        <Handlers>
          <RenderIf condition={!!title}>
            <Title>{title}</Title>
          </RenderIf>
          <RenderIf condition={!!handleOnHelpClick}>
            <QuestionIcon fontSize='large' onClick={handleOnHelpClick} />
          </RenderIf>
          <RenderIf condition={!!handleChange}>
            <label htmlFor={`file-upload_${id}`}>
              <PlusIcon fontSize='large' />
            </label>
          </RenderIf>
          <RenderIf condition={!!background && !!onDelete}>
            <RemoveIcon fontSize='large' onClick={() => setIsConfirmationOpen(true)} />
          </RenderIf>
        </Handlers>
      </FileInputContainer>
      <HiddenInput id={`file-upload_${id}`} type='file' onChange={handleChange} />
      <ConfirmationModal
        isOpen={isConfirmationOpen}
        onClose={() => setIsConfirmationOpen(false)}
        onConfirm={() => {
          onDelete?.()
          setIsConfirmationOpen(false)
        }}
        message={`Are you sure you want to delete ${title}?`}
        headerTitle={`Delete ${title}`}
      />
    </>
  )
}

type FileInputProps = {
  id: string
  onChange: (e: any) => void
  onDelete?: () => void
  background?: string
  height?: number
  width?: number
  title?: string
  onHelpClick?: () => void
}
